import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SignDetail } from '../../../../model/sign/sign-detail';
import { SignParticipatingCompany } from '../../../../model/sign/sign-participating-company';
import { SignsControllerRequestService } from '../../../../services/api/signs-controller-request.service';
import { SubscriptionBasedComponent } from '../../../../subscription-helpers/subscription-based.component';
import { cloneDeep } from 'lodash';
import { SignRecupMethod } from 'src/app/model/sign/enums/sign-recup-method';

@Component({
  selector: 'sign-entry',
  templateUrl: './sign-entry.component.html',
  styleUrls: ['./sign-entry.component.scss'],
})
export class SignEntryComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  sign: SignDetail;
  signCopy: SignDetail;

  constructor(
    private signsService: SignsControllerRequestService,
    private activated: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(this.activated.params, (params) => {
      this.routerEntry(params.id);
    });
  }

  private routerEntry(entry: string): void {
    const id: number = parseInt(entry);

    if (id > 0) {
      this.fetchDetail(id);
    } else {
      this.sign = this.constructNewSign();
      this.signCopy = cloneDeep(this.sign);
    }
  }

  private constructNewSign(): SignDetail {
    const sign = new SignDetail();
    sign.titleAdjustments = [];
    sign.phoneNumberAdjustments = [];
    sign.examples = [];
    sign.participatingCompanies = [];
    sign.participatingCompanies.push(new SignParticipatingCompany());

    return sign;
  }

  private fetchDetail(id: number): void {
    this.signsService.getById(id).then((res) => {
      this.sign = res;
      this.signCopy = cloneDeep(this.sign);
    });
  }

  onSignSaved(savedSign: SignDetail): void {
    this.sign = savedSign;
    this.signCopy = cloneDeep(this.sign);
  }

  onRoofLocationChanged(roofLocation: string): void {
    this.sign.roofLocation = roofLocation;
    this.signCopy.roofLocation = roofLocation;
  }

  onRecupMethodChanged(recupMethod: SignRecupMethod): void {
    this.sign.recupMethod = recupMethod;
    this.signCopy.recupMethod = recupMethod;
  }
}
